/*
    Create by li.pengyang 2016-01-25
*/
'use strict';
angular
    .module('trsPrintModule', ['util.httpService'])
    .factory('trsPrintService', [
        '$modal',
        function($modal) {
            return {
                trsPrintDocument: function(params) {
                    var picUrl = [];

                    for (var i = 0; i < params.length; i++) {
                        if (params[i].METALOGOURL && params[i].PICSLOGO == 1) {
                            if (params[i].METALOGOURL != undefined) {
                                picUrl = params[i].METALOGOURL.PICSLOGO.split(',');
                                params[i].PICURLTEMP = picUrl;
                            }
                        }
                    }
                    $modal.open({
                        template: '<div><trs_print></trs_print></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsIwoPrintDocument: function(params) {
                    $modal.open({
                        template: '<div><trs_iwo_print></trs_iwo_print></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsIwoPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsWebPrintDocument: function(params) {
                    $modal.open({
                        template: '<div><trs_web_print></trs_web_print></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsWebPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsTvPrintDocument: function(params, themeFlower) {
                    $modal.open({
                        template: '<div><trs_tv_print></trs_tv_print></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsTvPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                            themeFlower: function() {
                                return themeFlower;
                            },
                        },
                    });
                },
                trsAppPrintDocument: function(params) {
                    $modal.open({
                        template: '<div><trs_app_print></trs_app_print></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsAppPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsWeixinPrintDocument: function(params) {
                    $modal.open({
                        template: '<div><trs_weixin_print></trs_weixin_print></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsWeixinPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintShare: function(resultArray) {
                    $modal.open({
                        template: '<div><trs-print-share></trs-print-share></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsPrintShareCtrl',
                        resolve: {
                            arr: function() {
                                return resultArray;
                            },
                        },
                    });
                },
                trsPrintBigData: function(params) {
                    $modal.open({
                        template: [
                            '<div class="publicModal">',
                            '<div class="header"><p>打印</p></div>',
                            '<div class="body"><trs-print-big-data></trs-print-big-data></div>',
                            '</div>',
                        ].join(''),
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsBigDataPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintXhsg: function(params) {
                    $modal.open({
                        template: '<div><trs-print-xhsg></trs-print-xhsg></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsXhsgPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintWeibo: function(params) {
                    $modal.open({
                        template: '<div><trs-print-Weibo></trs-print-Weibo></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsWeiboPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintRobot: function(params) {
                    $modal.open({
                        template: [
                            '<div class="publicModal">',
                            '<div class="header"><p>打印</p></div>',
                            '<div class="body"><trs-print-Robot></trs-print-Robot></div>',
                            '</div>',
                        ].join(''),
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsRobotPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintDateList: function(params) {
                    $modal.open({
                        template: '<div class="trsPrintDateOuter"><trs_print_date params="params"></trs_print_date></div>',
                        windowClass: 'print-date-window',
                        backdrop: false,
                        controller: 'trsPrintDateCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintTopic: function(params) {
                    $modal.open({
                        template: '<div><trs-print-topic></trs-print-topic></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsPrintTopicCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
                trsPrintHistoryPictures: function(params) {
                    $modal.open({
                        template: '<div><trs-print-history-pictures></trs-print-history-pictures></div>',
                        windowClass: 'printCtrl',
                        backdrop: false,
                        controller: 'trsHistoryPicturesPrintCtrl',
                        resolve: {
                            params: function() {
                                return params;
                            },
                        },
                    });
                },
            };
        },
    ])
    .directive('trsPrintShare', [
        '$compile',
        '$timeout',
        'trsHttpService',
        function($compile, $timeout, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printShare_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintHistoryPictures', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printHistoryPictures_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintBigData', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printBigData_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintXhsg', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printXhsg_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintWeibo', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printWeibo_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintRobot', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printRobot_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrint', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/print_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsIwoPrint', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/iwoPrint_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsWebPrint', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/websitePrint_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsTvPrint', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/television_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsAppPrint', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/appPrint_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsWeixinPrint', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/weixinPrint_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintTopic', [
        '$compile',
        'trsHttpService',
        function($compile, trsHttpService) {
            return {
                restrict: 'E',
                templateUrl: './components/service/print/template/printTopic_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    // LazyLoad.js(["./lib/jquery-migrate/jquery-migrate.min.js", "./lib/jquery.jqprint/jquery.jqprint-0.3.js"], function() {
                    //     $(iElement[0]).jqprint();
                    // });
                },
            };
        },
    ])
    .directive('trsPrintDate', [
        '$compile',
        '$timeout',
        'trsHttpService',
        function($compile, $timeout, trsHttpService) {
            return {
                restrict: 'E',
                scope: {
                    params: '=',
                },
                templateUrl: './components/service/print/template/printDate_tpl.html',
                link: function(scope, iElement, iAttrs) {
                    LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                        var nPageHeight = 1230;
                        var trs = $(iElement).find('tr');
                        // $('.print-date-window').eq(0).find(".modal-dialog").width(window.screen.width * (925 / 1920))
                        var height = 0;
                        var beforeHTML = [
                            '<div class="trsPrintDate_container"><div class="trsPrintDate_header">',
                            '<div>' + scope.params.sourceName + '目录打印</div><div>日期：' + scope.params.date,
                            '</div><div class="clear"></div></div>',
                            '<div class="trsPrintDate_main"><table class="table">',
                            '<thead>',
                            '<th class="trsPrintDate-table-num">序号</th>',
                            '<th class="trsPrintDate-table-title">标题</th>',
                            '<th class="trsPrintDate-table-count">字数</th>',
                            '<th class="trsPrintDate-table-time">入库时间</th>',
                            '<th class="trsPrintDate-table-info">稿件信息</th>',
                            '</thead>',
                            '<tbody>',
                        ].join('');
                        var afterHTML = ['</tbody></table><hr/><div style="page-break-before:always;"></div></div></div>'].join('');

                        var aHtml;
                        var index;
                        for (index = 1; index < trs.size(); index++) {
                            if (height == 0) {
                                aHtml = [beforeHTML];
                            }
                            height += trs.eq(index).height();
                            if (height >= nPageHeight) {
                                aHtml.push(afterHTML);

                                // append to document
                                var sHtml = aHtml.join('');
                                iElement.before(sHtml);
                                height = 0;
                                index--;
                                continue;
                            }

                            aHtml.push('<tr>', trs.eq(index).html(), '</tr>');
                        }

                        aHtml.push(afterHTML);
                        var sHtml = aHtml.join('');
                        iElement.before(sHtml);
                        iElement.hide();
                        iElement.parent().jqprint();
                    });
                },
            };
        },
    ])
    .controller('trsPrintCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'params',
        '$filter',
        function($scope, $modalInstance, $timeout, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsHistoryPicturesPrintCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'params',
        '$filter',
        function($scope, $modalInstance, $timeout, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsBigDataPrintCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        '$filter',
        function($scope, $modalInstance, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsXhsgPrintCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'params',
        '$filter',
        function($scope, $modalInstance, $timeout, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsWeiboPrintCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'params',
        '$filter',
        function($scope, $modalInstance, $timeout, params, $filter) {
            initStatus();
            // $timeout(function() {
            //     print();
            // }, 1000);
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
                // IR_THUMBNAIL_PIC
            }
            // 插入图片
            $scope.appendPic = function(item) {
                var imgArr =
                    (!!item.IR_THUMBNAIL_PIC && item.IR_THUMBNAIL_PIC.split(';')) ||
                    (!!item.IR_RETWEETED_THUMBNAIL_PIC && item.IR_RETWEETED_THUMBNAIL_PIC.split(';')) ||
                    [];
                angular.forEach(imgArr, function(value, key) {
                    item.CONTENT += '<p><img src="' + value + '"/></p>';
                });
            };
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description] 打印方法
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsRobotPrintCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        '$filter',
        function($scope, $modalInstance, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsIwoPrintCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        '$filter',
        function($scope, $modalInstance, params, $filter) {
            initStatus();

            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsWebPrintCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        '$filter',
        function($scope, $modalInstance, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsTvPrintCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        '$filter',
        'trsspliceString',
        'themeFlower',
        function($scope, $modalInstance, params, $filter, trsspliceString, themeFlower) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                $scope.themeFlower = themeFlower;
                for (var i = 0; i < $scope.printItems.length; i++) {
                    $scope.printItems[i].broadcastArr = trsspliceString.spliceString($scope.printItems[i].BROADCASTING, 'USERNAME', ',');
                    $scope.printItems[i].reporterArr = trsspliceString.spliceString($scope.printItems[i].FGD_AUTHINFO, 'USERNAME', ',');
                    $scope.printItems[i].editArr = trsspliceString.spliceString($scope.printItems[i].FGD_EDITINFO, 'USERNAME', ',');
                    $scope.printItems[i].EXATTRIBUTE = $scope.printItems[i].EXATTRIBUTE instanceof Array ? $scope.printItems[i].EXATTRIBUTE : [];
                }
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsAppPrintCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'params',
        '$filter',
        function($scope, $modalInstance, $timeout, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsWeixinPrintCtrl', [
        '$scope',
        '$modalInstance',
        'params',
        '$filter',
        function($scope, $modalInstance, params, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.printItems = params;
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
            }
            $scope.parseHang = function(doccount) {
                return Math.ceil(doccount / 27);
            };

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsPrintShareCtrl', [
        '$scope',
        '$modalInstance',
        'arr',
        '$filter',
        function($scope, $modalInstance, arr, $filter) {
            initStatus();
            $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
                print();
            });

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
                $scope.resultArray = arr;
            }

            /**
             * [print description]
             * @return  {[type]}  [return description]
             */
            function print() {
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsPrintTopicCtrl', [
        '$scope',
        '$modalInstance',
        '$filter',
        function($scope, $modalInstance, $filter) {
            initStatus();

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                var date = new Date();
                $scope.date = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
                LazyLoad.js(['./lib/jquery-migrate/jquery-migrate.min.js', './lib/jquery.jqprint/jquery.jqprint-0.3.js'], function() {
                    $('printcontainer')
                        .eq(0)
                        .jqprint({}, function() {
                            $modalInstance.close('success');
                        });
                });
            }
        },
    ])
    .controller('trsPrintDateCtrl', [
        '$scope',
        '$modalInstance',
        '$timeout',
        'params',
        function($scope, $modalInstance, $timeout, params) {
            initStatus();

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.params = params;
                $timeout(function() {
                    $modalInstance.close('success');
                }, 1000);
            }
        },
    ]);
